import { render, staticRenderFns } from "./SendCredential.vue?vue&type=template&id=4dff109a"
import script from "./SendCredential.vue?vue&type=script&lang=js"
export * from "./SendCredential.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports